(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vc-anheften"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vc-anheften')) {
    var vcAnAlle = [];
    // Alle in zwei Durchgängen: erst alles lesen, dann alles schreiben (kein Hin und Her zwischen Layout und Stil)
    var vcAnAlleMessen = function () {
      var liste = vcAnAlle.slice();
      var werte = liste.map(function (el) { return el.lesen(); });
      liste.forEach(function (el, i) { el.schreiben(werte[i]); });
    };
    var vcAnSpaeter = function () { setTimeout(vcAnAlleMessen, 60); setTimeout(vcAnAlleMessen, 400); };
    // Wächst oder schrumpft irgendeine Section (Bilder laden nach, Inhalt kommt später), ändert sich ihr Behälter (main):
    // dann alle neu messen. So stimmt die Fläche auch, wenn eine Section darüber oder dazwischen erst später Höhe bekommt.
    var vcAnBehaelter = window.ResizeObserver ? new ResizeObserver(function () { vcAnAlleMessen(); }) : null;
    var vcAnStart = false;
    customElements.define('vc-anheften', class extends HTMLElement {
      connectedCallback() {
        if (vcAnAlle.indexOf(this) === -1) vcAnAlle.push(this);
        this.flaeche = this.querySelector('.vc-an__flaeche');
        this.marke = this.querySelector(':scope > .vc-editor-marke');
        this.ziel = null;
        this._ist = null;
        var ich = this.closest('.shopify-section') || this.parentElement;
        var beh = ich && ich.parentElement;
        if (vcAnBehaelter && beh && !beh._vcAnBeobachtet) { beh._vcAnBeobachtet = true; vcAnBehaelter.observe(beh); }
        this.messen();
        requestAnimationFrame(this.messen.bind(this));
        if (!vcAnStart) {
          vcAnStart = true;
          window.addEventListener('resize', vcAnAlleMessen);
          window.addEventListener('load', vcAnAlleMessen);
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(vcAnAlleMessen);
          ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:section:select', 'shopify:block:select'].forEach(function (n) {
            document.addEventListener(n, vcAnSpaeter);
          });
        }
      }
      disconnectedCallback() {
        var i = vcAnAlle.indexOf(this);
        if (i !== -1) vcAnAlle.splice(i, 1);
        if (this._ro) { this._ro.disconnect(); this._ro = null; }
        this.ziel = null;
        this._ist = null;
      }
      /** Die Section, an der dieses Element hängt: die nächste mit Inhalt darüber oder darunter (ohne andere Ebenen und Abstände). */
      zielFinden() {
        var ich = this.closest('.shopify-section') || this.parentElement;
        if (!ich) return null;
        var weg = this.dataset.ziel === 'darunter' ? 'nextElementSibling' : 'previousElementSibling';
        var x = ich[weg];
        while (x) {
          var leer = x.offsetHeight < 4 || x.tagName === 'STYLE' || x.tagName === 'SCRIPT' || x.querySelector(':scope > vc-anheften, :scope > .vc-ebene, :scope > .vc-abstand, :scope > .vc-null');
          if (!leer) return x;
          x = x[weg];
        }
        return null;
      }
      messen() { this.schreiben(this.lesen()); }
      /** Nur lesen: Lage und Größe der Ziel-Section im Verhältnis zu diesem Element. null: gerade nicht zu messen. */
      lesen() {
        if (!this.flaeche || !this.isConnected) return null;
        // Ausgeblendet (z. B. "nur Handy" am Rechner): nichts messen, beim nächsten resize wieder
        if (!this.getClientRects().length) return null;
        var ziel = this.zielFinden();
        if (ziel !== this.ziel) {
          if (this._ro) { this._ro.disconnect(); this._ro = null; }
          this.ziel = ziel;
          if (ziel && window.ResizeObserver) {
            var el = this;
            this._ro = new ResizeObserver(function () { el.messen(); });
            this._ro.observe(ziel);
          }
        }
        var w = { o: 0, l: 0, b: 0, h: 0, ziel: !!ziel, marke: 0 };
        if (ziel) {
          var t = ziel.getBoundingClientRect(), m = this.getBoundingClientRect();
          w.o = Math.round(t.top - m.top); w.l = Math.round(t.left - m.left); w.b = Math.round(t.width); w.h = Math.round(t.height);
        }
        // Im Editor: Etiketten weiterer Sections ohne Höhe an derselben Grenze zählen, damit keins das andere verdeckt
        if (this.marke) {
          var x = (this.closest('.shopify-section') || this).previousElementSibling;
          while (x && x.offsetHeight < 4) { if (x.querySelector('.vc-editor-marke')) w.marke++; x = x.previousElementSibling; }
        }
        return w;
      }
      /** Nur schreiben, und nur, was sich geändert hat. */
      schreiben(w) {
        if (!w) return;
        var alt = this._ist || {};
        this._ist = w;
        if (this.marke && w.marke !== alt.marke) this.marke.style.setProperty('--vc-marke-i', w.marke);
        if (w.ziel !== alt.ziel) {
          this.classList.toggle('vc-an--bereit', w.ziel);
          this.classList.toggle('vc-an--ohne-ziel', !w.ziel);
        }
        if (!w.ziel || (w.o === alt.o && w.l === alt.l && w.b === alt.b && w.h === alt.h && alt.ziel)) return;
        var f = this.flaeche.style;
        f.setProperty('--an-o', w.o + 'px');
        f.setProperty('--an-l', w.l + 'px');
        f.setProperty('--an-b', w.b + 'px');
        f.setProperty('--an-h', w.h + 'px');
        this.dispatchEvent(new CustomEvent('vc:anheften', { detail: { breite: w.b, hoehe: w.h } }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vc-basis"] && !Shopify.designMode) return;
  try {
    var VC = window.VC = window.VC || {};
  document.documentElement.classList.add('vc-js');
  VC.ruhig = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
  VC.editor = function () { return !!(window.Shopify && window.Shopify.designMode); };
  VC.wurzel = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };

  /** Preis in Cent als Text, z. B. 2499 -> "24,99 €". */
  VC.preis = function (cent) {
    var w = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: w }).format((Number(cent) || 0) / 100); }
    catch (e) { return ((Number(cent) || 0) / 100).toFixed(2).replace('.', ',') + ' ' + w; }
  };

  /**
   * In den Warenkorb. Der VC Warenkorb sieht die Anfrage selbst und geht auf. Ohne ihn: Warenkorb des Themes
   * (Impact: cart-drawer), sonst die Warenkorb-Seite. Gibt ein Promise, das bei Fehlern mit der Meldung von Shopify abbricht.
   */
  VC.inDenWarenkorb = function (variante, menge) {
    var wurzel = VC.wurzel();
    return window.fetch(wurzel + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variante), quantity: Math.max(1, Number(menge) || 1) }] })
    }).catch(function () {
      throw new Error('Keine Verbindung. Bitte nochmal versuchen.');
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Das hat nicht geklappt. Bitte nochmal versuchen.');
        return j;
      });
    }).then(function (j) {
      if (window.VCWK) return j;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.show === 'function') d.show();
      else window.location.href = wurzel + 'cart';
      return j;
    });
  };

  /** Ansage für Screenreader (eine gemeinsame Zeile für alle VC Sections). */
  VC.melden = function (text) {
    var z = document.getElementById('vc-meldung');
    if (!z) {
      z = document.createElement('div');
      z.id = 'vc-meldung';
      z.setAttribute('role', 'status');
      z.setAttribute('aria-live', 'polite');
      z.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
      document.body.appendChild(z);
    }
    z.textContent = '';
    setTimeout(function () { z.textContent = text; }, 60);
  };

  /** Knopf "In den Warenkorb" mit Lade-Zustand und Meldung. Klicks während der Anfrage oder der Meldung zählen nicht. */
  VC.kaufKnopf = function (knopf, variante, menge) {
    if (!knopf || knopf.getAttribute('aria-busy') === 'true' || knopf.dataset.vcMeldung) return;
    if (!knopf.dataset.vcText) knopf.dataset.vcText = knopf.innerHTML;
    knopf.setAttribute('aria-busy', 'true');
    return VC.inDenWarenkorb(variante, menge).then(function () {
      knopf.removeAttribute('aria-busy');
      VC.melden('Im Warenkorb');
    }, function (e) {
      knopf.removeAttribute('aria-busy');
      knopf.dataset.vcMeldung = '1';
      knopf.classList.add('vc-knopf--meldung');
      knopf.textContent = e.message;
      VC.melden(e.message);
      setTimeout(function () {
        knopf.innerHTML = knopf.dataset.vcText;
        knopf.classList.remove('vc-knopf--meldung');
        delete knopf.dataset.vcMeldung;
      }, 2600);
    });
  };

  /**
   * Die sichtbare Hintergrundfarbe an einer Kante einer Section: von innen nach außen das erste Element mit
   * deckender Farbe, das fast die ganze Breite hat. unten=true: an der Unterkante, sonst an der Oberkante.
   * Deckt dort nichts (durchsichtige Section), die Farbe der Seite. null, wenn dort ein Bild oder Verlauf liegt.
   */
  VC.farbeAnKante = function (sektion, unten) {
    if (!sektion) return null;
    var r = sektion.getBoundingClientRect();
    if (r.height < 2) return null;
    var kandidaten = [sektion].concat(Array.prototype.slice.call(sektion.querySelectorAll('*')));
    var treffer = null;
    for (var i = 0; i < kandidaten.length; i++) {
      var el = kandidaten[i];
      var b = el.getBoundingClientRect();
      if (b.width < r.width * 0.9 || b.height < 2) continue;
      if (unten ? Math.abs(b.bottom - r.bottom) > 3 : Math.abs(b.top - r.top) > 3) continue;
      var st = window.getComputedStyle(el);
      if (st.visibility === 'hidden' || st.display === 'none') continue;
      if (st.backgroundImage && st.backgroundImage !== 'none' && !/^url\(.*\.svg/.test(st.backgroundImage)) { treffer = 'bild'; continue; }
      var f = st.backgroundColor;
      var m = /rgba?\(([^)]+)\)/.exec(f || '');
      if (!m) continue;
      var teile = m[1].split(/[\s,\/]+/).filter(Boolean);
      var a = teile.length > 3 ? parseFloat(teile[3]) : 1;
      if (a < 0.95) continue;
      treffer = f;
    }
    if (treffer === 'bild') return null;
    return treffer || VC.seitenFarbe();
  };

  /** Bei "Bewegung reduzieren": Videos mit Autoplay anhalten und die Steuerung zeigen. */
  VC.videosRuhig = function (wurzel) {
    if (!VC.ruhig()) return;
    (wurzel || document).querySelectorAll('.vc-s video[autoplay]').forEach(function (v) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) {}
      v.controls = true;
    });
  };
  VC.videosRuhig();
  document.addEventListener('shopify:section:load', function (e) { VC.videosRuhig(e.target); });

  /**
   * Die Skripte der Sections liegen als eigene Dateien (assets/vc-*.js) und laden über ein <script> am Ende der Section,
   * also nur auf Seiten, auf denen die Section steht. Fügt der Theme-Editor eine Section ohne Neuladen ein, läuft ein
   * eingefügtes <script> nicht von selbst: dann hier nachladen (jede Datei höchstens einmal).
   */
  VC.skripteNachladen = function (wurzel) {
    var geladen = window.VCJS || {};
    VC._laedt = VC._laedt || {};
    Array.prototype.forEach.call((wurzel || document).querySelectorAll('script[data-vc-js]'), function (s) {
      var name = s.getAttribute('data-vc-js');
      if (!name || !s.src || geladen[name] || VC._laedt[name]) return;
      VC._laedt[name] = true;
      var neu = document.createElement('script');
      neu.src = s.src;
      document.head.appendChild(neu);
    });
  };
  document.addEventListener('shopify:section:load', function (e) { VC.skripteNachladen(e.target); });

  /** Farbe der Seite selbst (body), wenn keine Section deckt. */
  VC.seitenFarbe = function () {
    var f = window.getComputedStyle(document.body).backgroundColor;
    return /rgba?\(/.test(f) && !/,\s*0\)$/.test(f) && f !== 'transparent' ? f : null;
  };
  /** Kante unten an einer Section: holt sich die Farbe vom oberen Rand der nächsten Section mit Inhalt. */
  if (!customElements.get('vc-kante')) {
    var kantenFarben = function () { document.querySelectorAll('vc-kante[data-auto=true]').forEach(function (k) { if (k.farbeHolen) k.farbeHolen(); }); };
    customElements.define('vc-kante', class extends HTMLElement {
      connectedCallback() { if (this.dataset.auto === 'true') { this.farbeHolen(); requestAnimationFrame(this.farbeHolen.bind(this)); } }
      farbeHolen() {
        var ich = this.closest('.shopify-section');
        if (!ich) return;
        var alle = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
        var n = null;
        for (var j = alle.indexOf(ich) + 1; j < alle.length; j++) { if (alle[j].getBoundingClientRect().height > 4) { n = alle[j]; break; } }
        var f = n ? VC.farbeAnKante(n, false) : VC.seitenFarbe();
        if (f) this.style.setProperty('--farbe-ist', f); else this.style.removeProperty('--farbe-ist');
      }
    });
    window.addEventListener('load', kantenFarben);
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (n) { document.addEventListener(n, function () { setTimeout(kantenFarben, 120); }); });
  }
  } catch(e) { console.error(e); }
})();

})();
